import { devLog } from "@/helper/helper";
import { useAppDispatch } from "@/hooks/useAppDispatch";
import { useAppSelector } from "@/hooks/useAppSelector";
import { CalculateGrid } from "@/redux/uq/uq-actions";
import { UPRow } from "@/types/types";
import { useEffect } from "react";
import { toast } from "react-toastify";

type Props = {
  saveUpFn: (grid?: UPRow[]) => Promise<void>;
};

const useUpdateRetirementAssets = ({ saveUpFn }: Props) => {
  const dispatch = useAppDispatch();
  const { gridSet, indexShift } = useAppSelector((state) => state.uq);
  const { household } = useAppSelector((state) => state.household);
  const { age1: age1Now } = useAppSelector((state) => state.household);
  const retirementAssets = household?.lastRetirementAssets ?? 0;
  const firstRowGridSnapshot = gridSet.find((row: UPRow) => row.Age.value === age1Now);
  const isDataRefreshRequired = firstRowGridSnapshot?.Retirement?.value !== retirementAssets;

  useEffect(() => {
    async function updateRetirementAssetsAsync() {
      if (!household?.externalCode || !gridSet?.length) return;
      const newGrid: UPRow[] = structuredClone(gridSet);
      const firstRow = newGrid.find((row) => row.Age.value === age1Now);

      if (!firstRow?.Retirement) {
        toast.error("Failed to update Retirement Assets value");
        return;
      }

      firstRow.Retirement = {
        ...firstRow.Retirement,
        value: retirementAssets,
        defaultValue: retirementAssets,
        manualChange: true,
      };

      devLog("Last retirement assets: ", retirementAssets);

      if (isDataRefreshRequired) {
        await dispatch(CalculateGrid(0, newGrid));
        devLog("Recalculating... ", { newGrid });
        await saveUpFn(newGrid);
      }
    }

    updateRetirementAssetsAsync();
  }, [household?.externalCode, age1Now, gridSet?.length, indexShift, isDataRefreshRequired]);
};

export default useUpdateRetirementAssets;
